import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { de_ListSegmentReferencesCommand, se_ListSegmentReferencesCommand } from "../protocols/Aws_restJson1";
export { $Command };
export class ListSegmentReferencesCommand extends $Command
    .classBuilder()
    .ep({
    ...commonParams,
})
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("Evidently", "ListSegmentReferences", {})
    .n("EvidentlyClient", "ListSegmentReferencesCommand")
    .f(void 0, void 0)
    .ser(se_ListSegmentReferencesCommand)
    .de(de_ListSegmentReferencesCommand)
    .build() {
}
